import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../client';
import { invalidateCollectionCache } from '../cacheInvalidation';
import type { CompleteOnboardingRequest, CompleteOnboardingResponse } from '../types';

export function useCompleteOnboarding() {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (data: CompleteOnboardingRequest) =>
            api.post<CompleteOnboardingResponse>('/api/onboarding/complete', data),
        onSuccess: () => {
            invalidateCollectionCache(queryClient);
        },
    });
}
